import { render, staticRenderFns } from "./ResetPasswordCode.vue?vue&type=template&id=69620a28"
import script from "./ResetPasswordCode.vue?vue&type=script&lang=js"
export * from "./ResetPasswordCode.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordCode.vue?vue&type=style&index=0&id=69620a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports